import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "title"]


const __default__ = {
    name: "ClientInfoPage"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    url: {},
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      target: "_blank",
      href: __props.url,
      title: __props.url
    }, _toDisplayString(__props.title ? __props.title : __props.url), 9, _hoisted_1)
  ]))
}
}

})